(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/login-iframe.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/login-iframe.js');

'use strict';

const LoginIframe = () => {
  const returnUrl = ReactRedux.useSelector(state => state.playerloginreact.returnUrl);
  return React.createElement("iframe", {
    className: "iamlogin-iframe",
    id: "iamlogin-iframe",
    sandbox: "allow-same-origin allow-scripts allow-forms allow-modals",
    src: "".concat(svs.core.urlMapping.get('authorizationPlayer'), "?rd=/authorization/post-authorization?returnUrl=").concat(encodeURIComponent(returnUrl))
  });
};
svs.playerLoginReact.sharedComponents.LoginIframe = LoginIframe;

 })(window);